import { fadeInAnimationLong, fadeInAnimationShort, styles } from 'consts';
import styled from 'styled-components';

const { animationLong, animationShort, white, progressBarGradient, fontMBank } = styles;

export const RealisedScreenContainer = styled.div`
  border-radius: 0.5rem;
  background: ${progressBarGradient};
  text-align: center;
  color: ${white};
  padding: 3.3125rem 1rem;
`;

export const RealisedScreenWrapper = styled.div`
  animation: ${animationShort};
  ${fadeInAnimationShort};
`;

export const RealisedScreenStatus = styled.div`
  font-size: 32px;
  line-height: 1.25;
  text-align: center;
  color: ${white};
  max-width: 250px;
  font-weight: 300;
  margin: 0 auto;
  font-family: ${fontMBank};
`;

export const RealisedScreenStatusText = styled.div`
  font-size: 2rem;
  font-weight: bold;
  line-height: 1.25;
  text-align: center;
  color: ${white};
  margin-bottom: 1.5rem;
  max-width: 25rem;
  margin: 0 auto;
`;

export const RealisedScreenIcon = styled.div`
  animation: ${animationLong};
  ${fadeInAnimationLong};
  img {
    width: 12.5rem;
    height: 9.375rem;
  }
  margin-bottom: 1.3rem;
  margin-top: 2.75rem;
`;

export const RealisedScreenMessage = styled.div`
  color: ${white};
  font-size: 1.375rem;
  line-height: 1.32;
  max-width: 25rem;
  margin: 0 auto;
  font-family: ${fontMBank};
  font-weight: 300;
`;
